import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";

import SoftBox from "../SoftBox";
import SoftButton from "../SoftButton";
import SoftTypography from "../SoftTypography";
import SoftSelect from "../SoftSelect";
import { UseUserDetails } from "../../hooks/auth";
import { UseSelectedWorkspace, UseUsersFullData } from "../../hooks/company";
import { UPDATE_HUB_ITEM } from "../../api/hub";

const AssignLinkSection = ({ id, url, type, assignedTo, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);

  const userDetails = UseUserDetails();
  const workspace = UseSelectedWorkspace();
  const usersData = UseUsersFullData();

  const { handleSubmit } = useForm({ shouldUnregister: false });

  const fetchUsersByGroupId = () => {
    setLoading(true);
    const filteredUsers = usersData
      .filter((user) => user.groupId === workspace._id)
      .map((item) => {
        const username = `${item.firstName} ${item.lastName}`;

        return {
          ...item,
          _id: item.userId,
          value: item.userId,
          label: username,
        };
      });

    setUsers(filteredUsers);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsersByGroupId();
  }, [usersData, workspace._id]);

  const triggerAssign = async () => {
    setAssigning(true);
    try {
      await UPDATE_HUB_ITEM({
        id,
        userId: userDetails._id,
        groupId: workspace._id,
        url,
        type,
        assignedTo: selectedUser,
      });

      toast.success("Link assigned successfully");
      onSuccess?.();
    } catch (error) {
      console.log("=== error", error.response);
    } finally {
      setAssigning(false);
    }
  };

  const getDefaultValue = () => {
    if (!id) return null;
    if (!assignedTo) return null;

    return assignedTo.map((item) => {
      const username = `${item.firstName} ${item.lastName}`;

      return {
        ...item,
        value: item._id,
        label: username,
      };
    });
  };

  return (
    <SoftBox sx={{ width: "100%" }}>
      <SoftBox sx={{ marginBottom: "1rem" }}>
        <SoftTypography
          variant="h4"
          sx={{ color: "#101828", fontSize: "18px", fontWeight: 600 }}
        >
          Assign Custom power link to Player
        </SoftTypography>
        <SoftTypography
          variant="caption"
          sx={{ color: "#667085", fontSize: "12px", display: "block", marginTop: "0.25rem" }}
        >
          Select a player from the list below to assign the power link
        </SoftTypography>
      </SoftBox>

      <form onSubmit={handleSubmit(triggerAssign)}>
        <SoftSelect
          name="isType"
          id="assign-player"
          className="custom-select-catgory"
          options={users}
          isMulti
          onChange={(option) => {
            setSelectedUser([...option]);
          }}
          defaultValue={getDefaultValue()}
          isLoading={loading}
          placeholder="Select player"
          styles={{
            control: {
              backgroundColor: "#fff !important",
              borderColor: "#D0D5DD",
              height: "100%",
              minWidth: "2.5rem",
            },
            placeholder: {
              color: "#98A2B3",
            },
            input: {
              color: "#344054",
            },
            singleValue: {
              color: "#344054",
            },
            valueContainer: {
              flexFlow: "row wrap",
              gap: "0.25rem",
              padding: "0.5rem 0.75rem",
            },
            indicatorsContainer: {
              alignItems: "start",
            },
          }}
        />
        <SoftTypography
          variant="caption"
          sx={{
            color: "#667085",
            fontSize: "12px",
            marginTop: "10px",
            display: "block",
          }}
        >
          You can pick more than one player
        </SoftTypography>

        <SoftBox
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <SoftButton
            color="primary"
            sx={{
              minWidth: "120px",
              textTransform: "none",
              borderRadius: "8px",
              color: "#fff",
            }}
            disabled={assigning}
            type="submit"
          >
            Assign{" "}
            {assigning && (
              <CircularProgress
                color="inherit"
                size="1rem"
                className="ml-2"
              />
            )}
          </SoftButton>
        </SoftBox>
      </form>
    </SoftBox>
  );
};

export default AssignLinkSection;
